import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

import { fetchOrganizationById, updateOrganizationName } from '@account_module/services';
import { ORGANIZATION_QUERY_KEY } from '@account_module/constants/queryKeys';
import { IUpdateOrganization } from '@account_module/types/Organizations';

export const useOrganization = (id: string) => {
  const queryClient = useQueryClient();

  const { data, isLoading } = useQuery({
    queryKey: [ORGANIZATION_QUERY_KEY.organization, id],
    queryFn: () => fetchOrganizationById(id),
    enabled: !!id,
  });

  const { mutateAsync: updateOrganization, isLoading: isUpdateLoading } = useMutation({
    mutationFn: async (payload: IUpdateOrganization) => await updateOrganizationName(id, payload),
    onSuccess: () => queryClient.invalidateQueries([ORGANIZATION_QUERY_KEY.organization]),
  });

  return { data, isLoading, updateOrganization, isUpdateLoading };
};
